// // import React, { useState } from 'react';

// // export default function SchoolCertificates() {
// //   // Search state for filtering certificates
// //   const [searchTerm, setSearchTerm] = useState("");

// //   // Real mapped PDFs matching your uploads exactly
// //   const certificatesData = [
// //     { id: 1, title: "Building Safety Certificate", pdfUrl: "./pdfs/School_Building_Safety_Certificate.pdf" },
// //     { id: 2, title: "Fire Safety No Objection Certificate (NOC)", pdfUrl: "./pdfs/Fire_Safety_No_Objection_Certificate.pdf" },
// //     { id: 3, title: "Certificate of Land", pdfUrl: "./pdfs/Certificate of Land 3410.21.pdf" },
// //     { id: 4, title: "School Affiliation Automation System (CBSE)", pdfUrl: "./pdfs/School Affiliation Re engineered automation system CBSE.pdf" },
// //     { id: 5, title: "Parents Teacher Association Members List", pdfUrl: "./pdfs/List Of Parents Teacher Association Members.pdf" },
// //     { id: 6, title: "Water Testing Analysis Report", pdfUrl: "./pdfs/Test Report Water testing 1259.pdf" },
// //     { id: 7, title: "School Affidavit Documentation", pdfUrl: "./pdfs/Affidavit 09.11.2021.pdf" },
// //     { id: 8, title: "Trust Deed Registration", pdfUrl: "./pdfs/TRUST-DEED.pdf" },
// //     { id: 9, title: "CBSE Mandatory Disclosure Circular", pdfUrl: "./pdfs/Circular01_2026639038229508601060.pdf" },
// //     { id: 10, title: "Academic Calendar & Fees Structure", pdfUrl: "./pdfs/calendar.pdf" },
// //   ];

// //   // Filter logic based on user search
// //   const filteredCertificates = certificatesData.filter(cert =>
// //     cert.title.toLowerCase().includes(searchTerm.toLowerCase())
// //   );

// //   return (
// //     <div className="certificates-section">
// //       <div className="container">
        
// //         {/* Section Header */}
// //         <div className="header-box">
// //           <span className="badge">MANDATORY PUBLIC DISCLOSURE</span>
// //           <h2 className="main-title">School Certificates & Compliance</h2>
// //           <div className="title-divider"></div>
// //           <p className="sub-heading">All official statutory documents and educational certifications in one place.</p>
// //         </div>

// //         {/* Search Bar Feature */}
// //         <div className="search-container">
// //           <input 
// //             type="text" 
// //             placeholder="Search certificates (e.g., Fire, Land, CBSE)..." 
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //             className="search-input"
// //           />
// //           <span className="search-icon">🔍</span>
// //         </div>
        
// //         {/* Responsive CSS Grid Container */}
// //         <div className="certificates-grid">
// //           {filteredCertificates.length > 0 ? (
// //             filteredCertificates.map((cert) => (
// //               <div className="cert-card" key={cert.id}>
// //                 {/* Top Blue Dynamic Border line */}
// //                 <div className="top-bar"></div>
                
// //                 {/* PDF Document Icon Container */}
// //                 <div className="icon-container">
// //                   <svg className="doc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// //                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
// //                     <polyline points="14 2 14 8 20 8"></polyline>
// //                     <line x1="16" y1="13" x2="8" y2="13"></line>
// //                     <line x1="16" y1="17" x2="8" y2="17"></line>
// //                     <polyline points="10 9 9 9 8 9"></polyline>
// //                   </svg>
// //                 </div>

// //                 {/* Title */}
// //                 <h3 className="cert-title">{cert.title}</h3>

// //                 {/* Footer Actions inside Card */}
// //                 <div className="card-footer">
// //                   <a 
// //                     href={cert.pdfUrl} 
// //                     target="_blank" 
// //                     rel="noopener noreferrer" 
// //                     className="view-btn"
// //                   >
// //                     View PDF <span>→</span>
// //                   </a>
                  
// //                   {/* Native Download Trigger Button */}
// //                   <a href={cert.pdfUrl} download className="download-icon-btn" title="Download File">
// //                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// //                       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
// //                       <polyline points="7 10 12 15 17 10"></polyline>
// //                       <line x1="12" y1="15" x2="12" y2="3"></line>
// //                     </svg>
// //                   </a>
// //                 </div>
// //               </div>
// //             ))
// //           ) : (
// //             <div className="no-results">No certificates match your search query.</div>
// //           )}
// //         </div>
// //       </div>

// //       {/* --- PURE CSS DESIGN STYLING --- */}
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

// //         .certificates-section {
// //           background-color: #f8fafc;
// //           padding: 80px 0;
// //           font-family: 'Plus Jakarta Sans', sans-serif;
// //           position: relative;
// //         }
        
// //         .container {
// //           max-width: 1200px;
// //           margin: 0 auto;
// //           padding: 0 30px;
// //         }

// //         .header-box {
// //           text-align: center;
// //           margin-bottom: 35px;
// //         }

// //         .badge {
// //           background: #e0f2fe;
// //           color: #0b69d0;
// //           padding: 6px 16px;
// //           border-radius: 50px;
// //           font-weight: 700;
// //           font-size: 11px;
// //           letter-spacing: 1px;
// //         }

// //         .main-title {
// //           font-size: 36px;
// //           font-weight: 800;
// //           color: #0f172a;
// //           margin: 15px 0 10px;
// //         }

// //         .title-divider {
// //           width: 60px;
// //           height: 4px;
// //           background: #0b69d0;
// //           margin: 0 auto 20px;
// //           border-radius: 10px;
// //         }

// //         .sub-heading {
// //           color: #64748b;
// //           font-size: 16px;
// //           max-width: 600px;
// //           margin: 0 auto;
// //           line-height: 1.6;
// //         }

// //         /* Modern Filter Bar Styling */
// //         .search-container {
// //           max-width: 500px;
// //           margin: 0 auto 50px;
// //           position: relative;
// //           box-shadow: 0 10px 25px rgba(0,0,0,0.03);
// //           border-radius: 12px;
// //         }

// //         .search-input {
// //           width: 100%;
// //           padding: 14px 20px 14px 45px;
// //           border: 1px solid #e2e8f0;
// //           border-radius: 12px;
// //           font-size: 15px;
// //           font-family: inherit;
// //           outline: none;
// //           transition: all 0.3s;
// //           box-sizing: border-box;
// //         }

// //         .search-input:focus {
// //           border-color: #0b69d0;
// //           box-shadow: 0 0 0 4px rgba(11, 105, 208, 0.1);
// //         }

// //         .search-icon {
// //           position: absolute;
// //           left: 16px;
// //           top: 50%;
// //           transform: translateY(-50%);
// //           font-size: 16px;
// //           color: #94a3b8;
// //         }

// //         /* Responsive 4-Column Grid Layout */
// //         .certificates-grid {
// //           display: grid;
// //           grid-template-columns: repeat(4, 1fr);
// //           gap: 25px;
// //         }

// //         /* Card Design with Smooth Lift Animations */
// //         .cert-card {
// //           background: #ffffff;
// //           border-radius: 18px;
// //           box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
// //           padding: 30px 24px;
// //           display: flex;
// //           flex-direction: column;
// //           align-items: flex-start;
// //           text-align: left;
// //           position: relative;
// //           overflow: hidden;
// //           min-height: 200px;
// //           border: 1px solid #e2e8f0;
// //           transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s;
// //         }

// //         .cert-card:hover {
// //           transform: translateY(-6px);
// //           box-shadow: 0 20px 30px rgba(15, 23, 42, 0.06);
// //           border-color: #cbd5e1;
// //         }

// //         /* Top Blue Accent Line (Expands on Card Hover) */
// //         .top-bar {
// //           position: absolute;
// //           top: 0;
// //           left: 0;
// //           width: 100%;
// //           height: 5px;
// //           background-color: #0b69d0;
// //           transition: height 0.2s ease;
// //         }
        
// //         .cert-card:hover .top-bar {
// //           height: 7px;
// //         }

// //         /* Document Icon Background Box */
// //         .icon-container {
// //           background-color: #f0f7ff;
// //           width: 52px;
// //           height: 52px;
// //           border-radius: 12px;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           margin-bottom: 22px;
// //           transition: background-color 0.3s;
// //         }

// //         .cert-card:hover .icon-container {
// //           background-color: #e0f2fe;
// //         }

// //         .doc-icon {
// //           width: 24px;
// //           height: 24px;
// //           color: #64748b;
// //           transition: color 0.3s;
// //         }

// //         .cert-card:hover .doc-icon {
// //           color: #0b69d0;
// //         }

// //         /* Title Styling */
// //         .cert-title {
// //           font-size: 17px;
// //           color: #0f172a;
// //           font-weight: 700;
// //           margin: 0 0 24px 0;
// //           line-height: 1.5;
// //           flex-grow: 1;
// //         }

// //         /* Footer Alignment inside Card */
// //         .card-footer {
// //           display: flex;
// //           align-items: center;
// //           justify-content: space-between;
// //           width: 100%;
// //           margin-top: auto;
// //         }

// //         /* View PDF Button */
// //         .view-btn {
// //           color: #0b69d0;
// //           font-weight: 700;
// //           font-size: 14px;
// //           text-decoration: none;
// //           display: inline-flex;
// //           align-items: center;
// //           gap: 6px;
// //           transition: color 0.2s;
// //         }

// //         .view-btn span {
// //           transition: transform 0.2s;
// //         }

// //         .view-btn:hover {
// //           color: #1d4ed8;
// //         }

// //         .view-btn:hover span {
// //           transform: translateX(4px);
// //         }

// //         /* Small Circular Download Button */
// //         .download-icon-btn {
// //           color: #94a3b8;
// //           background: #f8fafc;
// //           width: 32px;
// //           height: 32px;
// //           border-radius: 50%;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           transition: all 0.2s;
// //           border: 1px solid #e2e8f0;
// //         }

// //         .download-icon-btn:hover {
// //           color: #0b69d0;
// //           background: #e0f2fe;
// //           border-color: #bae6fd;
// //         }

// //         .no-results {
// //           grid-column: 1 / -1;
// //           text-align: center;
// //           padding: 40px;
// //           color: #64748b;
// //           font-size: 16px;
// //         }

// //         /* Smooth Breakpoints for Grid Layout */
// //         @media (max-width: 1200px) {
// //           .certificates-grid { grid-template-columns: repeat(3, 1fr); }
// //         }
// //         @media (max-width: 900px) {
// //           .certificates-grid { grid-template-columns: repeat(2, 1fr); }
// //           .main-title { font-size: 30px; }
// //         }
// //         @media (max-width: 550px) {
// //           .certificates-grid { grid-template-columns: 1fr; }
// //           .container { padding: 0 20px; }
// //         }
// //       `}</style>
// //     </div>
// //   );
// // }

// import React, { useState } from 'react';

// export default function SchoolCertificates() {
//   // Search state for filtering certificates
//   const [searchTerm, setSearchTerm] = useState("");

//   // Real mapped PDFs matching your uploads exactly
//   const certificatesData = [
//     { id: 1, title: "Building Safety Certificate", pdfUrl: "./pdfs/School_Building_Safety_Certificate.pdf" },
//     { id: 2, title: "Fire Safety No Objection Certificate (NOC)", pdfUrl: "./pdfs/Fire_Safety_No_Objection_Certificate.pdf" },
//     { id: 3, title: "Certificate of Land", pdfUrl: "./pdfs/Certificate of Land 3410.21.pdf" },
//     { id: 4, title: "School Affiliation Automation System (CBSE)", pdfUrl: "./pdfs/School Affiliation Re engineered automation system CBSE.pdf" },
//     { id: 5, title: "Parents Teacher Association Members List", pdfUrl: "./pdfs/List Of Parents Teacher Association Members.pdf" },
//     { id: 6, title: "Water Testing Analysis Report", pdfUrl: "./pdfs/Test Report Water testing 1259.pdf" },
//     { id: 7, title: "School Affidavit Documentation", pdfUrl: "./pdfs/Affidavit 09.11.2021.pdf" },
//     { id: 8, title: "Trust Deed Registration", pdfUrl: "./pdfs/TRUST-DEED.pdf" },
//     { id: 9, title: "CBSE Mandatory Disclosure Circular", pdfUrl: "./pdfs/Circular01_2026639038229508601060.pdf" },
//     { id: 10, title: "Academic Calendar & Fees Structure", pdfUrl: "./pdfs/calendar.pdf" },
//   ];

//   // Filter logic based on user search
//   const filteredCertificates = certificatesData.filter(cert =>
//     cert.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="certificates-section">
//       <div className="container">
        
//         {/* Section Header */}
//         <div className="header-box">
//           <span className="badge">MANDATORY PUBLIC DISCLOSURE</span>
//           <h2 className="main-title">School Certificates & Compliance</h2>
//           <div className="title-divider"></div>
//           <p className="sub-heading">All official statutory documents and educational certifications in one place.</p>
//         </div>

//         {/* Search Bar Feature */}
//         <div className="search-container">
//           <input 
//             type="text" 
//             placeholder="Search certificates (e.g., Fire, Land, CBSE)..." 
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         {/* Responsive CSS Grid Container */}
//         <div className="certificates-grid">
//           {filteredCertificates.length > 0 ? (
//             filteredCertificates.map((cert) => (
//               <div className="cert-card" key={cert.id}>
//                 {/* Top Blue Dynamic Border line */}
//                 <div className="top-bar"></div>
                
//                 {/* PDF Document Icon Container */}
//                 <div className="icon-container">
//                   <svg className="doc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//                     <polyline points="14 2 14 8 20 8"></polyline>
//                     <line x1="16" y1="13" x2="8" y2="13"></line>
//                     <line x1="16" y1="17" x2="8" y2="17"></line>
//                     <polyline points="10 9 9 9 8 9"></polyline>
//                   </svg>
//                 </div>

//                 {/* Title */}
//                 <h3 className="cert-title">{cert.title}</h3>

//                 {/* Footer Actions inside Card */}
//                 <div className="card-footer">
//                   <a 
//                     href={cert.pdfUrl} 
//                     target="_blank" 
//                     rel="noopener noreferrer" 
//                     className="view-btn"
//                   >
//                     View PDF <span>→</span>
//                   </a>
                  
//                   {/* Native Download Trigger Button */}
//                   <a href={cert.pdfUrl} download className="download-icon-btn" title="Download File">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//                       <polyline points="7 10 12 15 17 10"></polyline>
//                       <line x1="12" y1="15" x2="12" y2="3"></line>
//                     </svg>
//                   </a>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="no-results">No certificates match your search query.</div>
//           )}
//         </div>
//       </div>

//       {/* --- PURE CSS DESIGN STYLING --- */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

//         .certificates-section {
//           background-color: #f8fafc;
//           padding: 80px 0;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           position: relative;
//         }
        
//         .container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 30px;
//         }

//         .header-box {
//           text-align: center;
//           margin-bottom: 35px;
//         }

//         .badge {
//           background: #e0f2fe;
//           color: #0b69d0;
//           padding: 6px 16px;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 11px;
//           letter-spacing: 1px;
//         }

//         .main-title {
//           font-size: 36px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 15px 0 10px;
//         }

//         .title-divider {
//           width: 60px;
//           height: 4px;
//           background: #0b69d0;
//           margin: 0 auto 20px;
//           border-radius: 10px;
//         }

//         .sub-heading {
//           color: #64748b;
//           font-size: 16px;
//           max-width: 600px;
//           margin: 0 auto;
//           line-height: 1.6;
//         }

//         /* Modern Filter Bar Styling */
//         .search-container {
//           max-width: 500px;
//           margin: 0 auto 50px;
//           position: relative;
//           box-shadow: 0 10px 25px rgba(0,0,0,0.03);
//           border-radius: 12px;
//         }

//         .search-input {
//           width: 100%;
//           padding: 14px 20px 14px 45px;
//           border: 1px solid #e2e8f0;
//           border-radius: 12px;
//           font-size: 15px;
//           font-family: inherit;
//           outline: none;
//           transition: all 0.3s;
//           box-sizing: border-box;
//         }

//         .search-input:focus {
//           border-color: #0b69d0;
//           box-shadow: 0 0 0 4px rgba(11, 105, 208, 0.1);
//         }

//         .search-icon {
//           position: absolute;
//           left: 16px;
//           top: 50%;
//           transform: translateY(-50%);
//           font-size: 16px;
//           color: #94a3b8;
//         }

//         /* Responsive 4-Column Grid Layout */
//         .certificates-grid {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           gap: 25px;
//         }

//         /* Card Design with Smooth Lift Animations */
//         .cert-card {
//           background: #ffffff;
//           border-radius: 18px;
//           box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
//           padding: 30px 24px;
//           display: flex;
//           flex-direction: column;
//           align-items: flex-start;
//           text-align: left;
//           position: relative;
//           overflow: hidden;
//           min-height: 200px;
//           border: 1px solid #e2e8f0;
//           transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s;
//         }

//         .cert-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 30px rgba(15, 23, 42, 0.06);
//           border-color: #cbd5e1;
//         }

//         /* Top Blue Accent Line (Expands on Card Hover) */
//         .top-bar {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 5px;
//           background-color: #0b69d0;
//           transition: height 0.2s ease;
//         }
        
//         .cert-card:hover .top-bar {
//           height: 7px;
//         }

//         /* Document Icon Background Box */
//         .icon-container {
//           background-color: #f0f7ff;
//           width: 52px;
//           height: 52px;
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 22px;
//           transition: background-color 0.3s;
//         }

//         .cert-card:hover .icon-container {
//           background-color: #e0f2fe;
//         }

//         .doc-icon {
//           width: 24px;
//           height: 24px;
//           color: #64748b;
//           transition: color 0.3s;
//         }

//         .cert-card:hover .doc-icon {
//           color: #0b69d0;
//         }

//         /* Title Styling */
//         .cert-title {
//           font-size: 17px;
//           color: #0f172a;
//           font-weight: 700;
//           margin: 0 0 24px 0;
//           line-height: 1.5;
//           flex-grow: 1;
//         }

//         /* Footer Alignment inside Card */
//         .card-footer {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           width: 100%;
//           margin-top: auto;
//         }

//         /* View PDF Button */
//         .view-btn {
//           color: #0b69d0;
//           font-weight: 700;
//           font-size: 14px;
//           text-decoration: none;
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           transition: color 0.2s;
//         }

//         .view-btn span {
//           transition: transform 0.2s;
//         }

//         .view-btn:hover {
//           color: #1d4ed8;
//         }

//         .view-btn:hover span {
//           transform: translateX(4px);
//         }

//         /* Small Circular Download Button */
//         .download-icon-btn {
//           color: #94a3b8;
//           background: #f8fafc;
//           width: 32px;
//           height: 32px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.2s;
//           border: 1px solid #e2e8f0;
//         }

//         .download-icon-btn:hover {
//           color: #0b69d0;
//           background: #e0f2fe;
//           border-color: #bae6fd;
//         }

//         .no-results {
//           grid-column: 1 / -1;
//           text-align: center;
//           padding: 40px;
//           color: #64748b;
//           font-size: 16px;
//         }

//         /* Smooth Breakpoints for Grid Layout */
//         @media (max-width: 1200px) {
//           .certificates-grid { grid-template-columns: repeat(3, 1fr); }
//         }
//         @media (max-width: 900px) {
//           .certificates-grid { grid-template-columns: repeat(2, 1fr); }
//           .main-title { font-size: 30px; }
//         }
//         @media (max-width: 550px) {
//           .certificates-grid { grid-template-columns: 1fr; }
//           .container { padding: 0 20px; }
//         }
//       `}</style>
//     </div>
//   );
// }

// import React, { useState } from 'react';

// export default function SchoolCertificates() {
//   // Search state for filtering certificates
//   const [searchTerm, setSearchTerm] = useState("");

//   // Real mapped PDFs matching your uploads exactly
//   const certificatesData = [
//     { id: 1, title: "Building Safety Certificate", pdfUrl: "./pdfs/School_Building_Safety_Certificate.pdf" },
//     { id: 2, title: "Fire Safety No Objection Certificate (NOC)", pdfUrl: "./pdfs/Fire_Safety_No_Objection_Certificate.pdf" },
//     { id: 3, title: "Certificate of Land", pdfUrl: "./pdfs/Certificate of Land 3410.21.pdf" },
//     { id: 4, title: "School Affiliation Automation System (CBSE)", pdfUrl: "./pdfs/School Affiliation Re engineered automation system CBSE.pdf" },
//     { id: 5, title: "Parents Teacher Association Members List", pdfUrl: "./pdfs/List Of Parents Teacher Association Members.pdf" },
//     { id: 6, title: "Water Testing Analysis Report", pdfUrl: "./pdfs/Test Report Water testing 1259.pdf" },
//     { id: 7, title: "School Affidavit Documentation", pdfUrl: "./pdfs/Affidavit 09.11.2021.pdf" },
//     { id: 8, title: "Trust Deed Registration", pdfUrl: "./pdfs/TRUST-DEED.pdf" },
//     { id: 9, title: "CBSE Mandatory Disclosure Circular", pdfUrl: "./pdfs/Circular01_2026639038229508601060.pdf" },
//     { id: 10, title: "Academic Calendar & Fees Structure", pdfUrl: "./pdfs/calendar.pdf" },
//   ];

//   // Filter logic based on user search
//   const filteredCertificates = certificatesData.filter(cert =>
//     cert.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="certificates-section">
//       <div className="container">
        
//         {/* Section Header */}
//         <div className="header-box">
//           <span className="badge">MANDATORY PUBLIC DISCLOSURE</span>
//           <h2 className="main-title">School Certificates & Compliance</h2>
//           <div className="title-divider"></div>
//           <p className="sub-heading">All official statutory documents and educational certifications in one place.</p>
//         </div>

//         {/* Search Bar Feature */}
//         <div className="search-container">
//           <input 
//             type="text" 
//             placeholder="Search certificates (e.g., Fire, Land, CBSE)..." 
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         {/* Responsive CSS Grid Container */}
//         <div className="certificates-grid">
//           {filteredCertificates.length > 0 ? (
//             filteredCertificates.map((cert) => (
//               <div className="cert-card" key={cert.id}>
//                 {/* Top Blue Dynamic Border line */}
//                 <div className="top-bar"></div>
                
//                 {/* PDF Document Icon Container */}
//                 <div className="icon-container">
//                   <svg className="doc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//                     <polyline points="14 2 14 8 20 8"></polyline>
//                     <line x1="16" y1="13" x2="8" y2="13"></line>
//                     <line x1="16" y1="17" x2="8" y2="17"></line>
//                     <polyline points="10 9 9 9 8 9"></polyline>
//                   </svg>
//                 </div>

//                 {/* Title */}
//                 <h3 className="cert-title">{cert.title}</h3>

//                 {/* Footer Actions inside Card */}
//                 <div className="card-footer">
//                   {/* target="_blank" की वजह से यह हमेशा बाहर नए टैब में फुल स्क्रीन खुलेगा */}
//                   <a 
//                     href={cert.pdfUrl} 
//                     target="_blank" 
//                     rel="noopener noreferrer" 
//                     className="view-btn"
//                   >
//                     View PDF <span>→</span>
//                   </a>
                  
//                   {/* Native Download Trigger Button */}
//                   <a href={cert.pdfUrl} download className="download-icon-btn" title="Download File">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//                       <polyline points="7 10 12 15 17 10"></polyline>
//                       <line x1="12" y1="15" x2="12" y2="3"></line>
//                     </svg>
//                   </a>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="no-results">No certificates match your search query.</div>
//           )}
//         </div>
//       </div>

//       {/* --- PURE CSS DESIGN STYLING --- */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

//         .certificates-section {
//           background-color: #f8fafc;
//           padding: 80px 0;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           position: relative;
//         }
        
//         .container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 30px;
//         }

//         .header-box {
//           text-align: center;
//           margin-bottom: 35px;
//         }

//         .badge {
//           background: #e0f2fe;
//           color: #0b69d0;
//           padding: 6px 16px;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 11px;
//           letter-spacing: 1px;
//         }

//         .main-title {
//           font-size: 36px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 15px 0 10px;
//         }

//         .title-divider {
//           width: 60px;
//           height: 4px;
//           background: #0b69d0;
//           margin: 0 auto 20px;
//           border-radius: 10px;
//         }

//         .sub-heading {
//           color: #64748b;
//           font-size: 16px;
//           max-width: 600px;
//           margin: 0 auto;
//           line-height: 1.6;
//         }

//         /* Modern Filter Bar Styling */
//         .search-container {
//           max-width: 500px;
//           margin: 0 auto 50px;
//           position: relative;
//           box-shadow: 0 10px 25px rgba(0,0,0,0.03);
//           border-radius: 12px;
//         }

//         .search-input {
//           width: 100%;
//           padding: 14px 20px 14px 45px;
//           border: 1px solid #e2e8f0;
//           border-radius: 12px;
//           font-size: 15px;
//           font-family: inherit;
//           outline: none;
//           transition: all 0.3s;
//           box-sizing: border-box;
//         }

//         .search-input:focus {
//           border-color: #0b69d0;
//           box-shadow: 0 0 0 4px rgba(11, 105, 208, 0.1);
//         }

//         .search-icon {
//           position: absolute;
//           left: 16px;
//           top: 50%;
//           transform: translateY(-50%);
//           font-size: 16px;
//           color: #94a3b8;
//         }

//         /* Responsive 4-Column Grid Layout */
//         .certificates-grid {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           gap: 25px;
//         }

//         /* Card Design with Smooth Lift Animations */
//         .cert-card {
//           background: #ffffff;
//           border-radius: 18px;
//           box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
//           padding: 30px 24px;
//           display: flex;
//           flex-direction: column;
//           align-items: flex-start;
//           text-align: left;
//           position: relative;
//           overflow: hidden;
//           min-height: 200px;
//           border: 1px solid #e2e8f0;
//           transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s;
//         }

//         .cert-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 30px rgba(15, 23, 42, 0.06);
//           border-color: #cbd5e1;
//         }

//         /* Top Blue Accent Line */
//         .top-bar {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 5px;
//           background-color: #0b69d0;
//           transition: height 0.2s ease;
//         }
        
//         .cert-card:hover .top-bar {
//           height: 7px;
//         }

//         /* Document Icon Background Box */
//         .icon-container {
//           background-color: #f0f7ff;
//           width: 52px;
//           height: 52px;
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 22px;
//           transition: background-color 0.3s;
//         }

//         .cert-card:hover .icon-container {
//           background-color: #e0f2fe;
//         }

//         .doc-icon {
//           width: 24px;
//           height: 24px;
//           color: #64748b;
//           transition: color 0.3s;
//         }

//         .cert-card:hover .doc-icon {
//           color: #0b69d0;
//         }

//         /* Title Styling */
//         .cert-title {
//           font-size: 17px;
//           color: #0f172a;
//           font-weight: 700;
//           margin: 0 0 24px 0;
//           line-height: 1.5;
//           flex-grow: 1;
//         }

//         /* Footer Alignment inside Card */
//         .card-footer {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           width: 100%;
//           margin-top: auto;
//         }

//         /* View PDF Button */
//         .view-btn {
//           color: #0b69d0;
//           font-weight: 700;
//           font-size: 14px;
//           text-decoration: none;
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           transition: color 0.2s;
//         }

//         .view-btn span {
//           transition: transform 0.2s;
//         }

//         .view-btn:hover {
//           color: #1d4ed8;
//         }

//         .view-btn:hover span {
//           transform: translateX(4px);
//         }

//         /* Small Circular Download Button */
//         .download-icon-btn {
//           color: #94a3b8;
//           background: #f8fafc;
//           width: 32px;
//           height: 32px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.2s;
//           border: 1px solid #e2e8f0;
//         }

//         .download-icon-btn:hover {
//           color: #0b69d0;
//           background: #e0f2fe;
//           border-color: #bae6fd;
//         }

//         .no-results {
//           grid-column: 1 / -1;
//           text-align: center;
//           padding: 40px;
//           color: #64748b;
//           font-size: 16px;
//         }

//         /* Smooth Breakpoints for Grid Layout */
//         @media (max-width: 1200px) {
//           .certificates-grid { grid-template-columns: repeat(3, 1fr); }
//         }
//         @media (max-width: 900px) {
//           .certificates-grid { grid-template-columns: repeat(2, 1fr); }
//           .main-title { font-size: 30px; }
//         }
//         @media (max-width: 550px) {
//           .certificates-grid { grid-template-columns: 1fr; }
//           .container { padding: 0 20px; }
//         }
//       `}</style>
//     </div>
//   );
// }

//  import React, { useState } from 'react';

// export default function SchoolCertificates() {
//   // Search state for filtering certificates
//   const [searchTerm, setSearchTerm] = useState("");
  
//   // State to manage which PDF is currently open in the iframe modal
//   const [activePdf, setActivePdf] = useState(null);

//   // Real mapped PDFs matching your uploads exactly
//   const certificatesData = [
//     { id: 1, title: "Building Safety Certificate", pdfUrl: "/pdfs/School_Building_Safety_Certificate.pdf" },
//     { id: 2, title: "Fire Safety No Objection Certificate (NOC)", pdfUrl: "/pdfs/Fire_Safety_No_Objection_Certificate.pdf" },
//     { id: 3, title: "Certificate of Land", pdfUrl: "/pdfs/Certificate of Land 3410.21.pdf" },
//     { id: 4, title: "School Affiliation Automation System (CBSE)", pdfUrl: "./pdfs/School Affiliation Re engineered automation system CBSE.pdf" },
//     { id: 5, title: "Parents Teacher Association Members List", pdfUrl: "./pdfs/List Of Parents Teacher Association Members.pdf" },
//     { id: 6, title: "Water Testing Analysis Report", pdfUrl: "./pdfs/Test Report Water testing 1259.pdf" },
//     { id: 7, title: "School Affidavit Documentation", pdfUrl: "./pdfs/Affidavit09112021.pdf" },
//     { id: 8, title: "Trust Deed Registration", pdfUrl: "./pdfs/TRUST-DEED.pdf" },
//     { id: 9, title: "CBSE Mandatory Disclosure Circular", pdfUrl: "./pdfs/Circular01_2026639038229508601060.pdf" },
//  { id: 10, title: "CBSE Mandatory Disclosure Fee", pdfUrl: "./pdfs/Fees.pdf" },
//  { id: 11, title: "CBSE Mandatory Disclosure ", pdfUrl: "./pdfs/MandatoryDisclosure.pdf" },
// ];

//   // Filter logic based on user search
//   const filteredCertificates = certificatesData.filter(cert =>
//     cert.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="certificates-section">
//       <div className="container">
        
//         {/* Section Header */}
//         <div className="header-box">
//           <span className="badge">DPS KIDS LADWA DISCLOSURE</span>
//           <h2 className="main-title">School Certificates & Compliance</h2>
//           <div className="title-divider"></div>
         
//           {/* <p className="sub-heading">All official statutory documents and educational certifications in one place.</p>
//         */}
//         </div>

//         {/* Search Bar Feature */}
//         <div className="search-container">
//           <input 
//             type="text" 
//             placeholder="Search certificates (e.g., Fire, Land, CBSE)..." 
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         {/* Responsive CSS Grid Container */}
//         <div className="certificates-grid">
//           {filteredCertificates.length > 0 ? (
//             filteredCertificates.map((cert) => (
//               <div className="cert-card" key={cert.id}>
//                 {/* Top Blue Dynamic Border line */}
//                 <div className="top-bar"></div>
                
//                 {/* PDF Document Icon Container */}
//                 <div className="icon-container">
//                   <svg className="doc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//                     <polyline points="14 2 14 8 20 8"></polyline>
//                     <line x1="16" y1="13" x2="8" y2="13"></line>
//                     <line x1="16" y1="17" x2="8" y2="17"></line>
//                     <polyline points="10 9 9 9 8 9"></polyline>
//                   </svg>
//                 </div>

//                 {/* Title */}
//                 <h3 className="cert-title">{cert.title}</h3>

//                 {/* Footer Actions inside Card */}
//                 <div className="card-footer">
//                   {/* Click trigger to open Iframe Modal */}
//                   <button 
//                     onClick={() => setActivePdf(cert)} 
//                     className="view-btn-trigger"
//                   >
//                     View PDF <span>→</span>
//                   </button>
                  
//                   {/* Native Download Trigger Button */}
//                   <a href={cert.pdfUrl} download className="download-icon-btn" title="Download File">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//                       <polyline points="7 10 12 15 17 10"></polyline>
//                       <line x1="12" y1="15" x2="12" y2="3"></line>
//                     </svg>
//                   </a>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="no-results">No certificates match your search query.</div>
//           )}
//         </div>
//       </div>

//       {/* --- FULL SCREEN IFRAME MODAL POPUP (MATCHED WITH FIRST COMPONENT) --- */}
//       {activePdf && (
//         <div className="modal-backdrop" onClick={() => setActivePdf(null)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            
//             {/* Modal Header - Matched with PdfViewer style */}
//             <div className="modal-header">
//               {/* <h4 className="modal-doc-title">📄 {activePdf.title}</h4>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}> */}
//                 {/* <a
//                   href={activePdf.pdfUrl}
//                   download
//                   className="modal-download-btn"
//                 >
//                   ⬇ Download
//                 </a> */}
//                 <button className="modal-close-btn" onClick={() => setActivePdf(null)}>
//                   ✕
//                 </button>
      
//             </div>
            
//             {/* Embedded Iframe Body */}
//             <div className="modal-body">
//               <iframe
//                 src={activePdf.pdfUrl}
//                 title={activePdf.title}
//                 className="pdf-iframe-view"
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* --- PURE CSS DESIGN STYLING --- */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

//         .certificates-section {
//           background-color: #f8fafc;
//           padding: 80px 0;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           position: relative;
//           margin-top:100px
//         }
        
//         .container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 30px;
//         }

//         .header-box {
//           text-align: center;
//           margin-bottom: 35px;
//         }

//         .badge {
//           background: #e0f2fe;
//           color: "rgb(0,111,47)";
//           padding: 6px 16px;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 11px;
//           letter-spacing: 1px;
//         }

//         .main-title {
//           font-size: 36px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 15px 0 10px;
//         }

//         .title-divider {
//           width: 60px;
//           height: 4px;
//           background: "rgb(0,111,47)";
//           margin: 0 auto 20px;
//           border-radius: 10px;
//         }

//         .sub-heading {
//           color: "rgb(0,111,47)";
//           font-size: 16px;
//           max-width: 600px;
//           margin: 0 auto;
//           line-height: 1.6;
//         }

//         .search-container {
//           max-width: 500px;
//           margin: 0 auto 50px;
//           position: relative;
//           box-shadow: 0 10px 25px rgba(0,0,0,0.03);
//           border-radius: 12px;
//         }

//         .search-input {
//           width: 100%;
//           padding: 14px 20px 14px 45px;
//           border: 1px solid #e2e8f0;
//           border-radius: 12px;
//           font-size: 15px;
//           font-family: inherit;
//           outline: none;
//           transition: all 0.3s;
//           box-sizing: border-box;
//         }

//         .search-input:focus {
//           border-color: "rgb(0,111,47)";
//           box-shadow: 0 0 0 4px rgba(11, 105, 208, 0.1);
//         }

//         .search-icon {
//           position: absolute;
//           left: 16px;
//           top: 50%;
//           transform: translateY(-50%);
//           font-size: 16px;
//           color: #94a3b8;
//         }

//         .certificates-grid {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           gap: 25px;
//         }

//         .cert-card {
//           background: #ffffff;
//           border-radius: 18px;
//           box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
//           padding: 30px 24px;
//           display: flex;
//           flex-direction: column;
//           align-items: flex-start;
//           text-align: left;
//           position: relative;
//           overflow: hidden;
//           min-height: 200px;
//           border: 1px solid #e2e8f0;
//           transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s;
//         }

//         .cert-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 20px 30px rgba(15, 23, 42, 0.06);
//           border-color: #cbd5e1;
//         }

//         .top-bar {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 5px;
//           background-color: "rgb(0,111,47)";
//           transition: height 0.2s ease;
//         }
        
//         .cert-card:hover .top-bar {
//           height: 7px;
//         }

//         .icon-container {
//           background-color: #f0f7ff;
//           width: 52px;
//           height: 52px;
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 22px;
//           transition: background-color 0.3s;
//         }

//         .cert-card:hover .icon-container {
//           background-color: #e0f2fe;
//         }

//         .doc-icon {
//           width: 24px;
//           height: 24px;
//           color: #64748b;
//           transition: color 0.3s;
//         }

//         .cert-card:hover .doc-icon {
//           color: "rgb(0,111,47)";
//         }

//         .cert-title {
//           font-size: 17px;
//           color: #0f172a;
//           font-weight: 700;
//           margin: 0 0 24px 0;
//           line-height: 1.5;
//           flex-grow: 1;
//         }

//         .card-footer {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           width: 100%;
//           margin-top: auto;
//         }

//         .view-btn-trigger {
//           color:"rgb(0,111,47)";
//           background: transparent;
//           border: none;
//           font-weight: 700;
//           font-size: 14px;
//           cursor: pointer;
//           padding: 0;
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           font-family: inherit;
//           transition: color 0.2s;
//         }

//         .view-btn-trigger span {
//           transition: transform 0.2s;
//         }

//         .view-btn-trigger:hover {
//           color: "rgb(0,111,47)";
//         }

//         .view-btn-trigger:hover span {
//           transform: translateX(4px);
//         }

//         .download-icon-btn {
//           color: #94a3b8;
//           background: #f8fafc;
//           width: 32px;
//           height: 32px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.2s;
//           border: 1px solid #e2e8f0;
//         }

//         .download-icon-btn:hover {
//           color: "rgb(0,111,47)";
//           background: #e0f2fe;
//           border-color: #bae6fd;
//         }

//         .no-results {
//           grid-column: 1 / -1;
//           text-align: center;
//           padding: 40px;
//           color: #64748b;
//           font-size: 16px;
//         }

//         /* =========================================
//            FULL SCREEN MODAL (PdfViewer Style)
//            ========================================= */
//         .modal-backdrop {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background-color: rgba(15, 23, 42, 0.6); 
//           backdrop-filter: blur(4px);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 9999;
//           animation: fadeIn 0.2s ease-out;
//         }

//         .modal-content {
//           background: #ffffff;
//           width: 100%;
//           height: 100vh; /* Full Height Screen */
//           display: flex;
//           flex-direction: column;
//           overflow: hidden;
//           animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
//         }

//         .modal-header {
//           height: 60px;
//           padding: 0 24px;
//           background: #1e293b; /* Dark theme Header like first component */
//           color: #ffffff;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           box-sizing: border-box;
//         }

//         .modal-doc-title {
//           margin: 0;
//           font-size: 16px;
//           font-weight: 700;
//           color: #ffffff;
//         }

//         .modal-download-btn {
//           background: "rgb(0,111,47)";
//           color: #fff;
//           padding: 6px 12px;
//           border-radius: 6px;
//           text-decoration: none;
//           font-size: 13px;
//           font-weight: 600;
//           transition: background 0.2s;
//         }

//         .modal-download-btn:hover {
//           background: #2563eb;
//         }

//         .modal-close-btn {
//           background: rgba(255, 255, 255, 0.1);
//           border: none;
//           color: #ffffff;
//           width: 32px;
//           height: 32px;
//           border-radius: 50%;
//           font-size: 12px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.2s;
//         }

//         .modal-close-btn:hover {
//           background: #ef4444;
//           color: #ffffff;
//         }

//         .modal-body {
//           flex: 1;
//           background: #f8fafc;
//           position: relative;
//         }

//         .pdf-iframe-view {
//           width: 100%;
//           height: 100%;
//           border: none;
//           background: #ffffff;
//         }

//         /* Animations */
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes slideUp {
//           from { transform: translateY(20px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }

//         /* Responsive Breakpoints */
//         @media (max-width: 1200px) {
//           .certificates-grid { grid-template-columns: repeat(3, 1fr); }
//         }
//         @media (max-width: 900px) {
//           .certificates-grid { grid-template-columns: repeat(2, 1fr); }
//           .main-title { font-size: 30px; }
//         }
//         @media (max-width: 550px) {
//           .certificates-grid { grid-template-columns: 1fr; }
//           .container { padding: 0 20px; }
//         }
//       `}</style>
//     </div>
//   );
// }

import React, { useState } from "react";

export default function SchoolCertificates() {
  const [searchTerm, setSearchTerm] = useState("");
  const [activePdf, setActivePdf] = useState(null);

  const certificatesData = [
    {
      id: 1,
      title: "Building Safety Certificate",
      pdfUrl: "/pdfs/School_Building_Safety_Certificate.pdf",
    },
    {
      id: 2,
      title: "Fire Safety No Objection Certificate (NOC)",
      pdfUrl: "/pdfs/FireCertificate.pdf",
    },
    {
      id: 3,
      title: "Certificate of Land",
      pdfUrl: "/pdfs/CertificateofLand.pdf",
    },
    {
      id: 4,
      title: "School Affiliation Automation System (CBSE)",
      pdfUrl: "./pdfs/SchoolAffiliation.pdf",
       
    },
    {
      id: 5,
      title: "Parents Teacher Association Members List",
      pdfUrl: "./pdfs/ParentsTeacher.pdf",
    },
    {
      id: 6,
      title: "Water Testing Analysis Report",
      pdfUrl: "./pdfs/Test Report Water testing 1259.pdf",
    },
    {
      id: 7,
      title: "School Affidavit Documentation",
      pdfUrl: "./pdfs/Affidavit.pdf",
    },
    {
      id: 8,
      title: "Trust Deed Registration",
      pdfUrl: "./pdfs/TRUST-DEED.pdf",
    },
    {
      id: 9,
      title: "CBSE Mandatory Disclosure Circular",
      pdfUrl: "./pdfs/Circular.pdf",
    },
    {
      id: 10,
      title: "CBSE Mandatory Disclosure Fee",
      pdfUrl: "./pdfs/Fees.pdf",
    },
    {
      id: 11,
      title: "CBSE Mandatory Disclosure",
      pdfUrl: "./pdfs/MandatoryDisclosure.pdf",
    },
  ];

  const filteredCertificates = certificatesData.filter((cert) =>
    cert.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="certificates-section">
      <div className="container">
        {/* HEADER */}
        <div className="header-box">
          <span className="badge">DPS KIDS LADWA DISCLOSURE</span>

          <h2 className="main-title">
            School Certificates & Compliance
          </h2>

          <div className="title-divider"></div>

          <p className="sub-heading">
            All official statutory documents and educational
            certifications in one place.
          </p>
        </div>

        {/* SEARCH */}
        <div className="search-container">
          <input
            type="text"
            placeholder="Search certificates..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />

          <span className="search-icon">🔍</span>
        </div>

        {/* GRID */}
        <div className="certificates-grid">
          {filteredCertificates.length > 0 ? (
            filteredCertificates.map((cert) => (
              <div className="cert-card" key={cert.id}>
                <div className="top-bar"></div>

                {/* ICON */}
                <div className="icon-container">
                  <svg
                    className="doc-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>

                    <polyline points="14 2 14 8 20 8"></polyline>

                    <line x1="16" y1="13" x2="8" y2="13"></line>

                    <line x1="16" y1="17" x2="8" y2="17"></line>

                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                </div>

                {/* TITLE */}
                <h3 className="cert-title">{cert.title}</h3>

                {/* FOOTER */}
                <div className="card-footer">
                  <button
                    onClick={() => setActivePdf(cert)}
                    className="view-btn-trigger"
                  >
                    View PDF <span>→</span>
                  </button>

                 
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              No certificates found.
            </div>
          )}
        </div>
      </div>

      {/* MODAL */}
      {activePdf && (
        <div
          className="modal-backdrop"
          onClick={() => setActivePdf(null)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="modal-header">
              <h4 className="modal-doc-title">
                {activePdf.title}
              </h4>

              <div className="modal-actions">
                

                <button
                  className="modal-close-btn"
                  onClick={() => setActivePdf(null)}
                >
                  ✕
                </button>
              </div>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <iframe
                src={activePdf.pdfUrl}
                title={activePdf.title}
                className="pdf-iframe-view"
              />
            </div>
          </div>
        </div>
      )}

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        * {
          box-sizing: border-box;
        }

        .certificates-section {
          width: 100%;
          padding: 110px 0 80px;
          background: #f5f7fb;
          font-family: 'Plus Jakarta Sans', sans-serif;
          overflow: hidden;
        }

        .container {
          width: 100%;
          max-width: 1400px;
          margin: auto;
          padding: 0 24px;
        }

        .header-box {
          text-align: center;
          margin-bottom: 45px;
        }

        .badge {
          display: inline-block;
          background: rgba(0,111,47,0.1);
          color: rgb(0,111,47);
          padding: 8px 18px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
        }

        .main-title {
          font-size: clamp(28px, 5vw, 48px);
          font-weight: 800;
          color: #0f172a;
          margin-top: 18px;
          line-height: 1.2;
        }

        .title-divider {
          width: 80px;
          height: 5px;
          background: rgb(0,111,47);
          margin: 18px auto;
          border-radius: 50px;
        }

        .sub-heading {
          max-width: 700px;
          margin: auto;
          font-size: 16px;
          line-height: 1.8;
          color: #64748b;
        }

        /* SEARCH */

        .search-container {
          position: relative;
          max-width: 600px;
          margin: 0 auto 55px;
        }

        .search-input {
          width: 100%;
          height: 60px;
          border-radius: 18px;
          border: 2px solid #e2e8f0;
          padding: 0 20px 0 55px;
          font-size: 15px;
          outline: none;
          background: #fff;
          transition: 0.3s;
          font-family: inherit;
        }

        .search-input:focus {
          border-color: rgb(0,111,47);
          box-shadow: 0 0 0 5px rgba(0,111,47,0.08);
        }

        .search-icon {
          position: absolute;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 18px;
        }

        /* GRID */

        .certificates-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 25px;
        }

        .cert-card {
          position: relative;
          background: #fff;
          border-radius: 24px;
          padding: 30px 24px;
          border: 1px solid #e2e8f0;
          overflow: hidden;
          transition: 0.35s ease;
          min-height: 250px;
          display: flex;
          flex-direction: column;
        }

        .cert-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 35px rgba(0,0,0,0.08);
        }

        .top-bar {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 6px;
          background: rgb(0,111,47);
        }

        .icon-container {
          width: 65px;
          height: 65px;
          border-radius: 18px;
          background: rgba(0,111,47,0.08);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
        }

        .doc-icon {
          width: 28px;
          height: 28px;
          color: rgb(0,111,47);
        }

        .cert-title {
          font-size: 18px;
          font-weight: 700;
          line-height: 1.6;
          color: #0f172a;
          flex: 1;
          margin-bottom: 30px;
        }

        .card-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
        }

        .view-btn-trigger {
          border: none;
          background: transparent;
          color: rgb(0,111,47);
          font-weight: 700;
          font-size: 15px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: 0.3s;
        }

        .view-btn-trigger span {
          transition: 0.3s;
        }

        .view-btn-trigger:hover span {
          transform: translateX(5px);
        }

        .download-icon-btn {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: rgba(0,111,47,0.08);
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgb(0,111,47);
          transition: 0.3s;
        }

        .download-icon-btn:hover {
          background: rgb(0,111,47);
          color: #fff;
        }

        .no-results {
          grid-column: 1 / -1;
          text-align: center;
          font-size: 18px;
          color: #64748b;
          padding: 50px 20px;
        }

        /* MODAL */

        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.65);
          backdrop-filter: blur(4px);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: fadeIn 0.3s ease;
        }

        .modal-content {
          width: 100%;
          height: 100vh;
          background: #fff;
          display: flex;
          flex-direction: column;
        }

        .modal-header {
          height: 70px;
          background: rgb(0,111,47);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          color: #fff;
          flex-shrink: 0;
        }

        .modal-doc-title {
          font-size: 16px;
          font-weight: 700;
          margin: 0;
        }

        .modal-actions {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .modal-download-btn {
          background: rgba(255,255,255,0.15);
          color: #fff;
          text-decoration: none;
          padding: 10px 16px;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          transition: 0.3s;
        }

        .modal-download-btn:hover {
          background: #fff;
          color: rgb(0,111,47);
        }

        .modal-close-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: none;
          background: rgba(255,255,255,0.15);
          color: #fff;
          cursor: pointer;
          font-size: 16px;
          transition: 0.3s;
        }

        .modal-close-btn:hover {
          background: #ef4444;
        }

        .modal-body {
          flex: 1;
          background: #f1f5f9;
        }

        .pdf-iframe-view {
          width: 100%;
          height: 100%;
          border: none;
        }

        /* RESPONSIVE */

        @media (max-width: 1200px) {
          .certificates-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 900px) {
          .certificates-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .container {
            padding: 0 20px;
          }
        }

        @media (max-width: 600px) {
          .certificates-section {
            padding-top: 95px;
          }

          .certificates-grid {
            grid-template-columns: 1fr;
            gap: 18px;
          }

          .cert-card {
            border-radius: 20px;
            padding: 24px 20px;
          }

          .main-title {
            font-size: 30px;
          }

          .sub-heading {
            font-size: 14px;
          }

          .search-input {
            height: 54px;
            border-radius: 14px;
            font-size: 14px;
          }

          .modal-header {
            padding: 0 12px;
          }

          .modal-doc-title {
            font-size: 13px;
            max-width: 180px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .modal-download-btn {
            padding: 8px 10px;
            font-size: 12px;
          }

          .modal-close-btn {
            width: 35px;
            height: 35px;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}